/**
 * GET /api/users/asset-conversion — menu ↔ API catalog from backend.
 */
import type { AssetConversionEntry } from './catalog';

export interface AssetConversionCatalog {
  menu: AssetConversionEntry[];
  convert_pairs: Array<{ from_asset: string; to_asset: string; label_zh?: string }>;
  convert_endpoint: string;
  rp_sp3_endpoint: string;
}

export function isInternalConvertPair(
  catalog: AssetConversionCatalog | undefined,
  from: string,
  to: string,
): boolean {
  const f = from.toLowerCase();
  const t = to.toLowerCase();
  if (!catalog?.convert_pairs?.length) return false;
  return catalog.convert_pairs.some((p) => p.from_asset === f && p.to_asset === t);
}
